// extracted by mini-css-extract-plugin
export var date = "index-module--date--MhQqY";
export var inner = "index-module--inner--qAWRN";
export var logo = "index-module--logo--xy0bA";
export var mediaReportsCard = "index-module--mediaReportsCard--jeMag";